import request from "../utils/request";
const apiPrefix = "/rent-collection";

export const getRentCollectionList = (params, config) => {
  return request.get(`${apiPrefix}/list`, { params, ...config });
};
export const getRentCollectionBillList = (contractId, params) => {
  console.log("getRentCollectionBillList contractId:", contractId);
  return request.get(`${apiPrefix}/bills/${contractId}`, { params });
};
export const getPaymentRecordList = (contractId) => {
  return request.get(`${apiPrefix}/payment-records/${contractId}`);
};
export const getRentContractDetail = (id) => {
  return request.get(`${apiPrefix}/detail/${id}`);
};
export const getValidHostOptions = () => {
  return request.get(`${apiPrefix}/validHostOptions`);
};
